<template>
    <el-dialog
        :visible.sync="showObj.changePwd"
        :modal-append-to-body=false
        :show-close=false>
        <div class="modal-title" v-show="!showSuccess">找回密码</div>
        <div class="form changePwd-form">
            <div class="ipts">
                <input class="ipt ipt-account"
                    @click="showWrongTip=false" type="text"
                    v-show="showAccoutIpt" v-model="email" placeholder="手机号/电子邮箱">
                <div class="verify-wrap" v-show="showCodeIpt">
                    <input class="ipt ipt-verify" type="text"
                        v-model="code" placeholder="验证码">
                    <span class="time" v-show="showCount">{{time}}s</span>
                    <span class="resend" v-show="!showCount" @click="findPwd(2)">重新发送</span>
                </div>
                <div class="newpwd-wrap ipt-wrap" v-show="showNewpwdIpt">
                    <input class="ipt ipt-newpwd" type="password"
                        v-if="!visiable" @click="showWrongTip=false" v-model="newpwd" placeholder="新密码">
                    <input class="ipt ipt-newpwd" type="text"
                        v-if="visiable" @click="showWrongTip=false" v-model="newpwd" placeholder="新密码">
                    <i @click="changeVisiable()" :class="{'text-icon': visiable}"></i>
                    <input v-model="confirm" @click="showWrongTip=false" class="ipt ipt-pwd" type="password" placeholder="确认密码">
                </div>
                <div class="reset-success" v-show="showSuccess">密码重置成功</div>
                <p class="wrong-tips" v-show="showWrongTip">{{wrongTips}}</p>
            </div>
            <div class="btns">
                <input class="btn btn-solid" type="button" v-show="showAccoutIpt" value="发送" @click="findPwd(1)">
                <input class="btn btn-solid" type="button" v-show="showCodeIpt" value="确定" @click="enterNewPwd()">
                <input class="btn btn-solid" type="button" v-show="showNewpwdIpt" value="确定" @click="resetPwd()">
                <input class="btn btn-solid" type="button" v-show="showSuccess" value="确定" @click="init()">
                <input class="btn btn-hollow" type="button" v-show="!showSuccess" value="取消" @click="showObj.changePwd = false">
            </div>
        </div>
        <div class="modal-footer">
            <a href="#" @click="turnToModal('login')" v-show="!showSuccess">返回登录</a>
        </div>
        <div class="btn-close" @click="showObj.changePwd = false"></div>
    </el-dialog>
</template>

<script>
    import axios from 'axios'
    export default {
        props: ["showObj"],
        data() {
            return {
                email: null,
                code: null,
                newpwd: null,
                confirm: null,
                showWrongTip: false,
                showAccoutIpt: true,
                showCodeIpt: false,
                showNewpwdIpt: false,
                showSuccess: false,
                showCount: true,
                time: 60,
                wrongTips: null,
                visiable: false
            };
        },
        methods: {
            init() {
                this.showObj.changePwd = false;
                this.email= null;
                this.code= null;
                this.newpwd= null;
                this.confirm= null;
                this.showWrongTip= false;
                this.showAccoutIpt= true;
                this.showCodeIpt= false;
                this.showNewpwdIpt= false;
                this.showSuccess= false;
                this.showCount= true;
                this.time= 60;
                this.wrongTips= null;
                this.visiable= false;
            },
            changeVisiable() {
                this.visiable = !this.visiable;
            },
            turnToModal(param) {
                // 这里会闪一下，并且右边滑动条不会消失
                for(var modal in this.showObj) {
                    this.showObj[modal] = false;
                }
                this.showObj[param] = true;
            },
            findPwd(times) {
                var that = this;
                var isLegal = that.verify(that.email);
                if(!isLegal) {
                    that.wrongTips = '该电子邮箱未注册';
                    that.showWrongTip = true;
                }else {
                    that.showWrongTip = false;
                    if(times > 1) {
                        that.time = 60;
                        that.showCount = true;
                    }
                    axios.post('/api/user/reset_pass/email', {
                        email: this.email,
                    })
                    .then(function (response) {
                        console.log(response.data);
                        if(response.data.code === 0) {
                            that.showCodeIpt = true;
                            that.showAccoutIpt = false;
                            that.countDown();
                        }else {
                            that.wrongTips = response.data.message;
                            that.showWrongTip = true;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            enterNewPwd() {
                var that = this;
                that.showNewpwdIpt = true;
                that.showCodeIpt = false;
            },
            resetPwd() {
                var that = this;
                if(that.newpwd.length < 8) {
                    that.wrongTips = '密码过短';
                    that.showWrongTip = true;
                }else if(that.newpwd.length > 18) {
                    that.wrongTips = '密码过长';
                    that.showWrongTip = true;
                }else if(that.newpwd !== that.confirm){
                    that.wrongTips = '两次输入密码不同';
                    that.showWrongTip = true;
                }else {
                    axios.post('/api/user/reset_pass/email/confirm', {
                        email: that.email,
                        code: that.code,
                        password: that.newpwd
                    })
                    .then(function (response) {
                        console.log(response.data);
                        if(response.data.code === 0) {
                            that.showNewpwdIpt = false;
                            that.showSuccess = true;
                        }else {
                            that.wrongTips = response.data.message;
                            that.showWrongTip = true;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            verify(str) {
                var patterns = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                if(patterns.test(str)) {
                    return true;
                }else {
                    return false;
                }
            },
            countDown() {
                var that = this;
                var timer = setInterval(function() {
                    that.time--;
                    if(that.time === 0) {
                        clearInterval(timer);
                        that.showCount = false;
                    }
                }, 1000);
            }
        }
    }
</script>

<style lang="scss" scoped>
    $maincolor: #0666b2;
    .modal-title {
        margin-top: 147px;
    }
    .modal-footer {
        justify-content: flex-end;
    }
    .wrong-tips {
        position: relative;
        padding-left: 22px;
        margin: -15px 60px 15px;
        font-size: 14px;
        color: #c33;
        &:before {
            content: "";
            position: absolute;
            top: -1px;
            left: 0;
            display: block;
            width: 16px;
            height: 16px;
            background-image: url("../../../static/img/wrong-tip.svg");
            background-size: 100%;
            background-repeat: no-repeat;
        }
    }
    .reset-success {
        position: relative;
        margin-top: 227px;
        margin-bottom: 66px;
        padding-left: 32px;
        text-align: center;
        &:before {
            content: "";
            position: absolute;
            top: -4px;
            left: 40%;
            width: 24px;
            height: 24px;
            background-image: url("../../../static/img/success.svg");
            background-size: 100%;
            background-repeat: no-repeat;
        }
    }
</style>



// WEBPACK FOOTER //
// Changepwd.vue?eb48058c